import * as React from 'react'
// interface CorruptedRow {
//   rowNumber: number;
//   data: string[];
//   error: string;
//   errorType: 'validation' | 'format' | 'missing';
// }
import './FileUploadErrorContent.scss'
import { CircleCross, CircleExclamation, CorruptFile, DownloadArrow, LoadCircle, Success, WarningTriangle } from './DashboardComps/SvgIcons';
import { Button } from 'react-bootstrap';
type ErrorTypes = 'fel antal kolumner' |'obalanserade citattecken (ojämnt antal ")' | 'flera separatorer i följd (;;)' | 'rad innehåller kontrolltecken' | 'sista korrekta rad innan fel' |'ogiltigt datum' | 'felvärde i'
interface CorruptedRowsDisplayProps {
  corruptedRows: any[];
  fileName: string;
  onRetry: () => void;
  onClose: () => void;
}

const errorConfig = {
  validation: {
    icon: <WarningTriangle width={20} height={20} fill='#374151'/>,//AlertTriangle,
    color: "warning",
    label: "Valideringsfel"
  },
  format: {
    icon: <CircleCross width={20} height={20} fill='white'/>,//XCircle,
    color: "destructive",
    label: "Formatfel"
  },
  missing: {
    icon: <CircleExclamation width={20} height={20} fill='#374151'/>,//AlertCircle,
    color: "secondary",
    label: "Saknade värden"
  },
  lastCorrect:{
    icon:<Success width={20} height={20}/>,
    color:'',
    label:"Sista korrekta raden innan fel"
  }

} as const;
export const FileUploadErrorContent = ({ 
  corruptedRows, 
  fileName, 
  onRetry, 
  onClose 
}: CorruptedRowsDisplayProps) =>{
   const errorCounts = {
    validation: corruptedRows.reduce((prev,curr) => {
        return prev + curr.reasons.filter((res:string) => res.includes('fel antal kolumner')).length
    },0),
    format:corruptedRows.reduce((prev,curr) => {
        return prev + curr.reasons.filter((res:string) => res.includes('obalanserade citattecken (ojämnt antal ")') || res.includes('flera separatorer i följd (;;)')).length
    },0),
    missing:corruptedRows.reduce((prev,curr) => {
        return prev + curr.reasons.filter((res:string) => res.includes('fel antal kolumner') || res.includes('ogiltigt datum')).length
    },0),
    lastCorrect:corruptedRows.reduce((prev,curr) => {
        return prev + curr.reasons.filter((res:string) => res.includes('sista korrekta rad innan fel')).length
    },0)
   }


//   const exportErrorReport = () => {
//     const report = corruptedRows.map(row => ({
//       Rad: row.id,
//     //   Feltyp: errorConfig[row.errorType].label,
//     //   Fel: row.error,
//       Data: row.rawData
//     }));
    
//     const csv = [
//       Object.keys(report[0]).join(','),
//       ...report.map(row => Object.values(row).map(val => `"${val}"`).join(','))
//     ].join('\n');
    
//     const blob = new Blob([csv], { type: 'text/csv' });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `fel-rapport-${fileName.replace(/\.[^/.]+$/, "")}.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };
const exportErrorReportTxt = () => {
  const rows: any[] = Array.isArray(corruptedRows) ? corruptedRows : [];
  const sourceFileName = typeof fileName === "string" && fileName.trim() ? fileName : "okänd-fil.csv";
  const nowIso = new Date().toISOString().replace(/\.\d{3}Z$/, "Z");

  // Hjälpare
  const CONTEXT_LABEL = "sista korrekta rad innan fel";

  const isContext = (reasons?: string[]) =>
    Array.isArray(reasons) && reasons.some(r => r && r.indexOf(CONTEXT_LABEL) === 0);

  const extractQuotedField = (s: string) => {
    const m = /"([^"]+)"/.exec(s);
    return m ? m[1] : "UNKNOWN";
  };

  const errorCode = (reason: string): string => {
    if (!reason) return "OTHER";
    if (reason.indexOf("ogiltigt datum") === 0) return "INVALID_DATE_" + extractQuotedField(reason);
    if (reason.indexOf("felvärde i") === 0) return "INVALID_VALUE_" + extractQuotedField(reason);
    if (reason.indexOf("fel antal kolumner") === 0) return "COLUMN_COUNT_MISMATCH";
    if (reason.indexOf("obalanserade citattecken") === 0) return "UNBALANCED_QUOTES";
    if (reason.indexOf(CONTEXT_LABEL) === 0) return "PRE_ERROR_CONTEXT";
    return "OTHER";
  };

  const suggestionForReason = (reason: string): string => {
    if (!reason) return "- Granska värdet mot datamallen.";
    if (reason.indexOf("obalanserade citattecken") === 0) {
      return '- Säkerställ att varje öppnande " stängs. Om text innehåller semikolon, omslut hela fältet med dubbla citattecken.';
    }
    if (reason.indexOf("fel antal kolumner") === 0) {
      return "- Antalet kolumner matchar inte. Räkna semikolon i raden och se till att de motsvarar antalet rubriker (oftast 13).";
    }
    if (reason.indexOf("ogiltigt datum") === 0) {
      return "- Datum ska vara på formatet YYYY-MM-DD i angivet fält.";
    }
    if (reason.indexOf("felvärde i") === 0) {
      return "- Värdet matchar inte datamallen/tillåtna listor. Jämför mot systemets tillåtna värden.";
    }
    if (reason.indexOf(CONTEXT_LABEL) === 0) {
      return "- Denna rad är korrekt. Felet uppstår vanligtvis direkt efter denna rad (t.ex. p.g.a. brutna citattecken).";
    }
    return "- Granska värdet mot datamallen.";
  };

  // Tom rapport
  if (!rows.length) {
    const minimal = [
      "FELRAPPORT FÖR IMPORT",
      "Filnamn: " + sourceFileName,
      "Genererad: " + nowIso,
      "",
      "Inga felrader registrerade."
    ].join("\n");

    const blob0 = new Blob([minimal], { type: "text/plain;charset=utf-8" });
    const url0 = URL.createObjectURL(blob0);
    const a0 = document.createElement("a");
    a0.href = url0;
    a0.download = "fel-rapport-" + sourceFileName.replace(/\.[^/.]+$/, "") + ".txt";
    a0.click();
    URL.revokeObjectURL(url0);
    return;
  }

  // indexera rows per id
  const byId: { [id: number]: any } = {};
  for (let i = 0; i < rows.length; i++) byId[rows[i].id] = rows[i];

  // anchors (kontext-rader)
  const anchors: { [id: number]: true } = {};
  for (let i = 0; i < rows.length; i++) {
    if (isContext(rows[i].reasons)) anchors[rows[i].id] = true;
  }

  // blockId-sökning utan Map/Set
  const findBlockId = (r: any): number => {
    if (isContext(r.reasons)) return r.id;
    let current: number | undefined = r.parsedIndex;
    const seen: { [id: number]: true } = {};
    while (typeof current === "number" && byId[current] && !seen[current]) {
      if (anchors[current]) return current;
      seen[current] = true;
      current = byId[current].parsedIndex;
    }
    return typeof r.parsedIndex === "number" ? r.parsedIndex : r.id;
  };

  // gruppera per blockId i plain object
  const groups: { [blockId: number]: any[] } = {};
  for (let i = 0; i < rows.length; i++) {
    const r = rows[i];
    const b = findBlockId(r);
    if (!groups[b]) groups[b] = [];
    groups[b].push(r);
  }

  // sortera blockIds och varje grupp på id
  let blockIds = Object.keys(groups).map(n => parseInt(n, 10));
  blockIds.sort((a, b) => a - b);
  for (let i = 0; i < blockIds.length; i++) {
    const b = blockIds[i];
    groups[b].sort((a, b) => a.id - b.id);
  }

  // statistik utan Map
  const errorCounts: { [code: string]: number } = {};
  let errorRowCount = 0;
  for (let i = 0; i < rows.length; i++) {
    const r = rows[i];
    const ctx = isContext(r.reasons);
    if (!ctx) errorRowCount++;
    const reasons = r.reasons || [];
    for (let j = 0; j < reasons.length; j++) {
      const code = errorCode(reasons[j]);
      if (code === "PRE_ERROR_CONTEXT") continue;
      errorCounts[code] = (errorCounts[code] || 0) + 1;
    }
  }
  // till array och sortera (code, count)
  const commonErrors: Array<[string, number]> = [];
  for (const k in errorCounts) {
    if (Object.prototype.hasOwnProperty.call(errorCounts, k)) {
      commonErrors.push([k, errorCounts[k]]);
    }
  }
  commonErrors.sort((a, b) => b[1] - a[1]);

  // bygg TXT
  const lines: string[] = [];
  lines.push("FELRAPPORT FÖR IMPORT");
  lines.push("Filnamn: " + sourceFileName);
  lines.push("Genererad: " + nowIso);
  lines.push("");
  lines.push("VAD ÄR DETTA?");
  lines.push("Denna TXT beskriver felaktiga rader från importen. Raderna grupperas i 'block' – varje block börjar med en 'kontext-rad' (sista korrekta rad innan felet) följt av en eller flera felrader som hänger ihop, ofta p.g.a. brutna citattecken.");
  lines.push("");
  lines.push("HUR ANVÄNDER JAG RAPPORTEN?");
  lines.push("1) Hitta blocket vars kontext-rad (Rad-ID) finns nära den plats där importen började fallera.");
  lines.push("2) Öppna originalfilen och leta upp kontext-raden med samma Rad-ID (index i ursprungsfilen).");
  lines.push("3) Korrigera felraderna efter kontexten utifrån tipsen under 'Att åtgärda'.");
  lines.push("4) Kör importen igen. Upprepa vid behov för nästa block.");
  lines.push("");
  lines.push("BEGREPP & NYCKLAR");
  lines.push("- Rad-ID: Indexet raden hade i originalfilen.");
  lines.push("- Kontext-rad: Sista korrekta rad innan fel (själv är den giltig).");
  lines.push("- Block-ID: Rad-ID för kontext-raden som blocket tillhör.");
  lines.push("- Rådata: Exakt text från originalfilen för respektive rad.");
  lines.push("");
  lines.push("SNABBSTATISTIK");
  lines.push("- Antal block: " + blockIds.length);
  lines.push("- Antal felrader: " + errorRowCount);
  lines.push("- Vanligaste feltyper:");
  if (commonErrors.length) {
    for (let i = 0; i < commonErrors.length; i++) {
      lines.push("    • " + commonErrors[i][0] + ": " + commonErrors[i][1]);
    }
  } else {
    lines.push("    • (Inga feltyper registrerade)");
  }
  lines.push("");

  // block-för-block
  for (let bi = 0; bi < blockIds.length; bi++) {
    const b = blockIds[bi];
    const group = groups[b];
    let contextRow: any | undefined;
    const fragments: any[] = [];

    for (let i = 0; i < group.length; i++) {
      const r = group[i];
      if (isContext(r.reasons)) contextRow = r;
      else fragments.push(r);
    }

    lines.push(Array(81).join("=")); // "=" * 80
    lines.push("BLOCK " + b + "  (fragment: " + fragments.length + ")");

    if (contextRow) {
      lines.push("Kontext-rad (Rad-ID " + contextRow.id + "):");
      lines.push("  Rådata: " + contextRow.rawData);
      const reasons = contextRow.reasons || [];
      for (let i = 0; i < reasons.length; i++) {
        if (reasons[i].indexOf(CONTEXT_LABEL) === 0) {
          lines.push("  Not: " + reasons[i]);
        }
      }
      lines.push("");
    }

    for (let i = 0; i < fragments.length; i++) {
      const r = fragments[i];
      lines.push("- Felrad (Rad-ID " + r.id + "):");
      lines.push("  Rådata: " + r.rawData);
      const reasons = r.reasons || [];
      lines.push("  Felorsaker (" + reasons.length + "):");
      for (let j = 0; j < reasons.length; j++) {
        lines.push("    • " + reasons[j] + "  [" + errorCode(reasons[j]) + "]");
      }
      // unika tips
      const tipsObj: { [tip: string]: true } = {};
      for (let j = 0; j < reasons.length; j++) {
        tipsObj[suggestionForReason(reasons[j])] = true;
      }
      lines.push("  Att åtgärda:");
      const tips = Object.keys(tipsObj);
      if (tips.length) {
        for (let t = 0; t < tips.length; t++) lines.push("    " + tips[t]);
      } else {
        lines.push("    - (Inga specifika tips tillgängliga)");
      }
      lines.push("");
    }
  }

  // Skriv fil och ladda ned
  const outName = "fel-rapport-" + sourceFileName.replace(/\.[^/.]+$/, "") + ".txt";
  const blob = new Blob([lines.join("\n")], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = outName;
  a.click();
  URL.revokeObjectURL(url);
};
 
  return (
    <div className="fileupload-error-container">
      {/* Header med filnamn och felsammanfattning */}
      <div className="fileupload-error-margin">
        <div className="fileupload-error-header-container">
          <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
          
          <CorruptFile height={25} fill='rgb(17, 24, 39)'/>
          <h3 className="fileupload-error-header-text">Import misslyckades</h3>
          </span>  
        </div>
        
        <div className="fileupload-error-card-border">
          <div className="fileupload-error-card-header-container-padding">
            <div className="fileupload-error-card-header-text-container">
              <span className="fileupload-error-card-header-text-destructive">Fil:</span>
              <span className="fileupload-error-card-header-text-filename">{fileName}</span>
            </div>
          </div>
          <div className="fileupload-error-card-content-margin">
            <p className="fileupload-error-card-content-paragraph">
              Filen innehåller <span className="fileupload-error-card-content-warningtext">{corruptedRows.length - errorCounts.lastCorrect}</span> korrupta rader som måste åtgärdas innan import kan genomföras.
            </p>
            
            <div className="fileupload-error-card-content-badge-container">
              {Object.entries(errorCounts).map(([type, count]) => {
                if (count === 0) return null;
                if(type === 'lastCorrect') return null;
                const config = errorConfig[type as keyof typeof errorConfig];
                
                
                return (
                  <div 
                    key={type} 
                    //variant={config.color as any}
                    className={`fileupload-error-card-content-badge fileupload-error-card-content-badge-${config.color}`}
                  >
                    {/* <Icon className="h-3 w-3" /> */}
                    {config.icon}
                    <span>{config.label}: {count}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Lista med korrupta rader */}
      <div className="fileupload-error-card-corrupt-items-list-container">
        <div>
          <div className="fileupload-error-card-corrupt-items-list-header-text">Detaljerad fellista</div>
        </div>
        <div className="fileupload-error-card-corrupt-items-list-content-container">
          <div style={{overflow:'scroll',maxHeight:'40vh'}} className="h-full max-h-96">
            <div className="fileupload-error-card-corrupt-items-list-content-paddmarg">
              {corruptedRows.map((row, index) => {
                 //const config = errorConfig[row.errorType];
                // const Icon = config.icon;
                
                return (
                  <div key={index} className={row.reasons.filter((x:string) => x.includes('sista korrekta rad innan fel')).length > 0 ? 'fileupload-error-card-corrupt-items-card-border-l-success':"fileupload-error-card-corrupt-items-card-border-l-destructive"}>
                    <div className="fileupload-error-card-corrupt-items-card-padd">
                      <div className="fileupload-error-card-corrupt-items-card-content-container">
                        <div className="fileupload-error-card-corrupt-items-card-content-container-text-container">
                          <div /*variant="outline"*/ className="fileupload-error-card-corrupt-items-card-content-container-text-row-number">
                            Rad {row.id}
                          </div>
                          <div /*variant={config.color as any}*/ className={row.reasons.filter((x:string) => x.includes('sista korrekta rad innan fel')).length > 0 ? 'fileupload-error-card-content-badge fileupload-error-card-content-badge-success':`fileupload-error-card-content-badge fileupload-error-card-content-badge-destructive`}>
                            {/* <Icon className="h-3 w-3" /> */}
                            {/* <span className="text-xs">{config.label}</span> */}
                          </div>
                        </div>
                      </div>
                      
                      <p className="fileupload-error-card-corrupt-items-card-content-container-text-row-error">
                        {row.error}
                      </p>
                      
                      <div className="fileupload-error-card-corrupt-items-card-content-container-bg">
                        <p className="fileupload-error-card-corrupt-items-card-content-container-bg-text">Raddata:</p>
                        <div className="fileupload-error-card-corrupt-items-card-content-container-rowdata-container">
                          {/* {row.data.map((cell:any, cellIndex:number) => (
                            <div 
                              key={cellIndex} 
                              //variant="secondary" 
                              className="text-xs font-mono"
                            >
                              {cell || '<tom>'}
                            </div>
                          ))} */}
                          {Object.entries(row.rawData

                          ).map(([key,value],index) => {
                            return(<div key={index} className='fileupload-error-card-corrupt-items-card-content-container-rowdata-item-text'>
                                {`${value}` || '<tom>'}
                            </div>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Action buttons */}
      <div className="fileupload-actionbutton-container">
        <Button 
        style={{display:'flex',justifyContent:'center',gap:4}}
          onClick={exportErrorReportTxt}
          className="button"
        >
          <DownloadArrow width={20} height={20} fill='white'/>
          <span>Exportera felrapport</span>
        </Button>
        
        <div className="fileupload-actionbutton-container-cildbutton-container">
          {/* <button onClick={onClose}>
            Stäng
          </button> */}
          {/* <Button 
          style={{display:'flex',justifyContent:'center',gap:4}}
            onClick={onRetry}
            className="button-cancel"
          >
          
            <LoadCircle width={20} height={20} fill='white'/>
            <span>Försök igen</span>
          </Button> */}
        </div>
      </div>
    </div>
  );
}